import React from 'react';
import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const HTML_RE = /<(p|div|br|table|html|span|strong|em|b|i|u|ul|ol|li|a|blockquote)\b[^>]*>/i;

export function isHtmlBody(body: string): boolean {
  return !!body && HTML_RE.test(body);
}

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['p', 'br', 'div', 'span', 'strong', 'em', 'b', 'i', 'u', 'ul', 'ol', 'li',
                 'table', 'thead', 'tbody', 'tr', 'td', 'th', 'a', 'blockquote'],
  ALLOWED_ATTR: ['href', 'style', 'class', 'target', 'rel'],
};

export function EmailBody({ body }: { body: string }): React.ReactElement {
  if (isHtmlBody(body)) {
    const clean = DOMPurify.sanitize(body, SANITIZE_CONFIG);
    return <div className="email-html-content" dangerouslySetInnerHTML={{ __html: clean }} />;
  }
  return (
    <pre className="content-text" data-emailbody-text style={{ whiteSpace: 'pre-wrap', margin: 0, fontFamily: 'inherit' }}>
      {body}
    </pre>
  );
}
